import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { useMatch, useParams } from "react-router-dom";
import { useLocationStore, usePipedriveStore } from "..";
import useCompaniesWithGlobalFilters from "./useCompaniesWithGlobalFilters";

export default function (): number[] {
    const urlParams = useParams();
    const isCompanyDetailsPage = useMatch("/companies/:id");
    const locationStore = useLocationStore();
    const pipedriveStore = usePipedriveStore();

    const filteredCompanies = useCompaniesWithGlobalFilters(pipedriveStore.organizations);
    const filteredCompanyIds = useMemo(() => new Set(filteredCompanies.map(c => c.id)), [filteredCompanies]);

    return useMemo(() => computed(() => {
        return _.uniq([
            ...locationStore.checkedCompanyIds,
            ...(isCompanyDetailsPage ? [Number(urlParams.id)] : []),
        ]).filter(id => filteredCompanyIds.has(id));
    }), [isCompanyDetailsPage, urlParams, filteredCompanyIds]).get();
}